import React, { useEffect } from 'react';
// Styles
import classes from './styles.module.scss';

const PrivacyPolicyPage:React.FC = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <section
      className={classes.page}
    >
      <div className="container">
        <h2 className={classes.title}>Privacy Policy</h2>
        <p className={classes.text}><strong>Effective date:</strong> August 31, 2025</p>

        <h3 className={classes.subtitle}>Data Controllers</h3>
        <p className={classes.text}>For EU/EEA/UK users, the data controller is <strong>Overmind OÜ</strong> (Estonia, EU).</p>
        <p className={classes.text}>For non-EU users, the data controller may be our Ukrainian entity, MouseOver LLC.</p>


        <h3 className={classes.subtitle}>Data We Collect</h3>
        <ul className={classes.list}>
          <li className={classes.listItem}>Contact information (name, email, phone, company details)</li>
          <li className={classes.listItem}>Billing and payment information</li>
          <li className={classes.listItem}>Technical information (IP, browser type, usage data)</li>
          <li className={classes.listItem}>Communications (support requests, proposals, contracts)</li>
        </ul>

        <h3 className={classes.subtitle}>Purposes & Legal Bases</h3>
        <p className={classes.text}>We use data to provide and manage our services, comply with legal obligations, improve our website, and, where applicable, send communications. The legal bases include contract performance, legal obligations, legitimate interest, and consent.</p>

        <h3 className={classes.subtitle}>Retention</h3>
        <p className={classes.text}>Data is retained only as long as necessary to fulfill the purposes stated or comply with applicable laws.</p>

        <h3 className={classes.subtitle}>Sharing</h3>
        <p className={classes.text}>We do not sell personal data. We share data only with service providers, affiliates, or authorities when legally required.</p>

        <h3 className={classes.subtitle}>International Transfers</h3>
        <p className={classes.text}>Data may be transferred between our entities in the EU and Ukraine. Safeguards are applied as required by GDPR.</p>

        <h3 className={classes.subtitle}>Your Rights</h3>
        <p className={classes.text}>You have rights of access, rectification, erasure, restriction, objection, and data portability. You may also withdraw consent or lodge complaints with supervisory authorities.</p>

        <h3 className={classes.subtitle}>Cookies</h3>
        <p className={classes.text}>Our website uses cookies for functionality and analytics. You can manage cookies through your browser settings.</p>

        <h3 className={classes.subtitle}>Changes</h3>
        <p className={classes.text}>We may update this policy from time to time. Updates will be posted here with a revised effective date.</p>

        <h3 className={classes.subtitle}>Contact</h3>
        <p className={classes.text}>Email: <a href="mailto:privacy@mouseover.io">privacy@mouseover.io</a></p>
        <p className={classes.text}>EU: Overmind OÜ, Harju maakond, Tallinn, Lasnamäe linnaosa, Sepapaja tn 6, 11415</p>
        <p className={classes.text}>Non-EU: MouseOver LLC, 79012, Ukraine, Lviv, Sakharova street 42</p>
      </div>
    </section>
  );
}

export default PrivacyPolicyPage;
